module.exports = "<p>{{'quoteandbind.pa.directives.templates.pa-quick-indicative.Getting your Quote...' | translate}}</p>"


/*****************
 ** WEBPACK FOOTER
 ** ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/quoteandbind/quickquote/pa/tiles/quote/directives/templates/pa-quick-quote-quoting-state.html
 ** module id = 843
 ** module chunks = 0
 **/